import { ScreenWrapperComponent } from 'components/layouts/ScreenWrapperComponent';

import './styles.scss';
import { ReactNode } from 'react';
import { Flex } from 'antd';

type AuthPageWrapperProps = {
  children: ReactNode;
  title?: ReactNode;
};

export const AuthPageWrapper = ({ children, title }: AuthPageWrapperProps) => (
  <ScreenWrapperComponent>
    <div className='content-wrapper'>
      <div className='form-card'>
        <div className='top-left-gradient' />
        <div className='bottom-right-gradient' />
        {title && (
          <Flex vertical gap={16} className='title-wrapper'>
            {title}
          </Flex>
        )}
        {children}
      </div>
    </div>
  </ScreenWrapperComponent>
);
